import { MarketingNewsletterEndpoint as MarketingNewsletterEndpointInterface } from "@/projectRoot/api-client/interfaces/endpoints/MarketingNewsletter.endpoint";
import ApiResponseDto from "@apiClient/interfaces/response/ApiResponse.dto";
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from "ky";
import NewsletterRequestDto from "@/projectRoot/api-client/interfaces/request/marketing/NewsletterRequest.dto";
import NewsletterDto from "@/projectRoot/api-client/interfaces/models/marketing/Newsletter.dto";
import { buildSearchParams } from "@/projectRoot/src/utils/handlers/urlHandler";
import NewsletterSingleByTemplateRequestDto from "@/projectRoot/api-client/interfaces/request/marketing/NewsletterSingleByTemplateRequest.dto";
import NewsletterSearchByTemplateRequestDto from "@/projectRoot/api-client/interfaces/request/marketing/NewsletterSearchByTemplateRequest.dto";
import PaginationDto from "@/projectRoot/api-client/interfaces/request/Pagination.dto";

export class MarketingNewsletterEndpoint implements MarketingNewsletterEndpointInterface {

    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "no-store") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
     * /api/marketing/newsletter/subscribe
     */
    async subscribe(params: NewsletterRequestDto): Promise<ApiResponseDto<NewsletterDto, undefined>> {
        return this._httpClient
            .post(`marketing/newsletter/subscribe`, { json: params, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<NewsletterDto, undefined> = await kyResponse.json();
                return response;
            });
    }


    /**
     * /api/marketing/newsletter/unsubscribe
     */
    async unsubscribe(params: NewsletterRequestDto): Promise<ApiResponseDto<NewsletterDto, undefined>> {
        return this._httpClient
            .post(`marketing/newsletter/unsubscribe`, { json: params, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<NewsletterDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/marketing/newsletter/get-subscriptions-by-template
     */
    async getSubscriptionsByTemplate(params: NewsletterRequestDto): Promise<ApiResponseDto<NewsletterDto, undefined>> {
        return this._httpClient
            .get(`marketing/newsletter/get-subscriptions-by-template`, {searchParams: buildSearchParams(params), cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<NewsletterDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/marketing/newsletter/single-by-template
     */
    async singleByTemplate(params: NewsletterSingleByTemplateRequestDto): Promise<ApiResponseDto<NewsletterDto, undefined>> {
        return this._httpClient
            .get(`marketing/newsletter/single-by-template`, {searchParams: buildSearchParams(params), cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<NewsletterDto, undefined> = await kyResponse.json();
                return response;
            });
    }

    /**
     * /api/marketing/newsletter/multiple-by-template
     */
    async multipleByTemplate(params: NewsletterSearchByTemplateRequestDto): Promise<ApiResponseDto<NewsletterDto[], PaginationDto>> {
        return this._httpClient
            .get(`marketing/newsletter/multiple-by-template`, { searchParams: buildSearchParams({ template: params.template }), cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<NewsletterDto[], PaginationDto> = await kyResponse.json();
                return response;
            });
    }
}

export default MarketingNewsletterEndpoint;